import React, { FC, useState, useEffect } from "react";
import { Card, Modal, Input, notification, Button, Form, Select } from "antd";
import { useMutation } from "@apollo/react-hooks";
import { ResendUser, DelUser } from "../../../graphql/user";
import { Aws } from "../../../common/Aws";
import { Titles } from "../../../common/Fr";
import { observer } from "mobx-react";
import { userEditStore } from "../../../store/user/UserEditStore";

export const EditUserDlg: FC<any> = observer(({ onClose }) => {
  const [form] = Form.useForm();

  const store = userEditStore;

  const [resendUser] = useMutation(ResendUser);
  const [delUser] = useMutation(DelUser);

  const [canDel, setCanDel] = useState(false);

  useEffect(() => {
    Aws.isManaging().then((ok) => setCanDel(ok));
  }, []);

  const save = () => {
    form.validateFields().then((values) => {
      userEditStore.save(values).then(() => {
        onClose(true);
      });
    });
  };

  const reInvitation = () => {
    resendUser({
      variables: {
        id: store.model.id,
      },
    }).then((res) => {
      notification.success({ message: `Invitation send` });
    });
  };

  const onDel = () => {
    Modal.confirm({
      title: "Are you sure delete this user?",
      onOk: () => {
        delUser({
          variables: { id: store.model.id },
        }).then((res) => {
          notification.success({ message: "User deleted!" });
          onClose(true);
        });
      },
    });
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const onValuesChange = (values) => {};

  return (
    <Modal
      className="user-details"
      title="Edit User Info"
      visible={true}
      confirmLoading={store.saving}
      maskClosable={false}
      onCancel={() => onClose()}
      bodyStyle={{ padding: 0 }}
      footer={null}
    >
      <Card loading={store.loading}>
        {store.model && (
          <Form form={form} {...layout} initialValues={{ ...store.model }} onValuesChange={onValuesChange}>
            <div style={{ textAlign: "right" }}>
              <Button.Group style={{ marginBottom: 20 }}>
                <Button
                  onClick={() => reInvitation()}
                  type="primary"
                  disabled={store.model?.poolInfo?.status !== "FORCE_CHANGE_PASSWORD"}
                >
                  Resend invitation
                </Button>
                <Button onClick={() => onDel()} danger disabled={canDel === false}>
                  DELETE
                </Button>
              </Button.Group>
            </div>
            <Form.Item label="Email (Username)" name="email">
              <Input disabled />
            </Form.Item>
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[{ required: true, message: "Please input first name" }]}
            >
              <Input maxLength={50} placeholder="Enter first name" />
            </Form.Item>
            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[{ required: true, message: "Please input last name" }]}
            >
              <Input maxLength={50} placeholder="Enter last name" />
            </Form.Item>

            <Form.Item
              label="Salutation"
              name="title"
              rules={[{ required: store.model.isTeacher, message: "Please select salutation" }]}
            >
              <Select placeholder="Select salutation" allowClear>
                {Titles.map((x) => (
                  <Select.Option value={x} key={x}>
                    {x}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            {/* <Form.Item label="Mobile Number" name="mobile" rules={[AsyncValid.mobile]}>
                  <NumberFormat format="+# (###) ###-####" mask="_" className="ant-input" />
                </Form.Item> */}

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button loading={store.saving} onClick={() => save()} type="primary">
                Save
              </Button>
            </Form.Item>
          </Form>
        )}
      </Card>
    </Modal>
  );
});
